import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const navigate = useNavigate();
  const [userSession, setUserSession] = useState(null);

  useEffect(() => {
    // Load user session from localStorage
    const storedSession = localStorage.getItem("userSession");
    if (storedSession) {
      setUserSession(JSON.parse(storedSession));
    }
  }, []);

  // useEffect(() => {
  //   const storedSession = localStorage.getItem("userSession");
  //   if (storedSession) {
  //     try {
  //       const parsedSession = JSON.parse(storedSession);
  //       if (parsedSession && parsedSession.expiryTime > Date.now()) {
  //         setUserSession(parsedSession);
  //       } else {
  //         console.warn("Session expired or invalid. Clearing it.");
  //         localStorage.removeItem("userSession");
  //       }
  //     } catch (error) {
  //       console.error("Error parsing userSession from localStorage:", error);
  //       localStorage.removeItem("userSession");
  //     }
  //   }
  // }, []);

  const login = (session) => {
    setUserSession(session);
    localStorage.setItem("userSession", JSON.stringify(session));
  };

  // const login = (session) => {
  //   const expiryTime = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
  //   setUserSession({ ...session, expiryTime });
  //   localStorage.setItem("userSession", JSON.stringify({ ...session, expiryTime }));
  // };

  const logout = async () => {
    try {
      const token = localStorage.getItem("x-auth-token");
      if (!token) {
        console.warn("No API token found. User may not be logged in.");
      }

      // Send logout request
      const response = await fetch(`${API_URL}/api/user/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${encodedCredentials}`,
          "x-auth-token": token,
        },
      });

      if (!response.ok) {
        console.error("Logout request failed:", response.statusText);
      }

     // CLEAR EVERYTHING RELATED TO THE USER
    setUserSession(null);

    localStorage.removeItem("userSession");
    localStorage.removeItem("x-auth-token");

    // IMPORTANT: clear project data
    localStorage.removeItem("projectInfo");
    localStorage.removeItem("companyName");
    localStorage.removeItem("applicatorId");
    localStorage.removeItem("savedUnitSystem");

      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ userSession, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
